import React, { lazy, Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { UnAutorizedContentRoute } from "../../../components/UnAuthorizedRoute/UnAuthorizedRoute";
import { LayoutSplashScreen } from "../../../context/LayoutContext";

const Login = lazy(() => import("./Login"));

export function AuthPage() {
  return (
    <>
      <Suspense fallback={<LayoutSplashScreen />}>
        <Switch>
          <UnAutorizedContentRoute path="/auth/login" component={Login} />
          <Redirect from="/auth" exact={true} to="/auth/login" />
          <Redirect to="/auth/login" />
        </Switch>
      </Suspense>
    </>
  );
}
